/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FieldRequest
 */
export interface FieldRequest {
    /**
     * URL-safe machine identifier for this field
     * @type {string}
     * @memberof FieldRequest
     */
    name: string;
    /**
     * Human-readable label displayed in the booking form
     * @type {string}
     * @memberof FieldRequest
     */
    title: string;
    /**
     * Helper text shown below the field in the booking form
     * @type {string}
     * @memberof FieldRequest
     */
    description: string;
    /**
     * The input type for this field
     * @type {string}
     * @memberof FieldRequest
     */
    type: FieldRequestTypeEnum;
    /**
     * Whether this field is required to complete a booking
     * @type {boolean}
     * @memberof FieldRequest
     */
    required: boolean;
}


/**
 * @export
 */
export const FieldRequestTypeEnum = {
    String: 'STRING',
    Text: 'TEXT',
    Boolean: 'BOOLEAN',
    Email: 'EMAIL',
    Phone: 'PHONE'
} as const;
export type FieldRequestTypeEnum = typeof FieldRequestTypeEnum[keyof typeof FieldRequestTypeEnum];


/**
 * Check if a given object implements the FieldRequest interface.
 */
export function instanceOfFieldRequest(value: object): value is FieldRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('required' in value) || value['required'] === undefined) return false;
    return true;
}

export function FieldRequestFromJSON(json: any): FieldRequest {
    return FieldRequestFromJSONTyped(json, false);
}

export function FieldRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FieldRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'title': json['title'],
        'description': json['description'],
        'type': json['type'],
        'required': json['required'],
    };
}

export function FieldRequestToJSON(json: any): FieldRequest {
    return FieldRequestToJSONTyped(json, false);
}

export function FieldRequestToJSONTyped(value?: FieldRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'title': value['title'],
        'description': value['description'],
        'type': value['type'],
        'required': value['required'],
    };
}

